import { render, staticRenderFns } from "./DatosEntrada.vue?vue&type=template&id=0c0172ac"
import script from "./DatosEntrada.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosEntrada.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports